import "./listClosed.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import DatatableClose from "../../components/datatableTicketClosed/DatatableClose";

const ListClosed = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <DatatableClose columns={columns}/>
      </div>
    </div>
  )
}

export default ListClosed
